import { SnackbarProvider } from "notistack";

const SnackbarContext = ({children}) => {
    return (
        <SnackbarProvider maxSnack={5}>
            {children}
        </SnackbarProvider>
    )
}

export default SnackbarContext;